export default __webpack_public_path__ + "static/media/31-min.49a72977.jpg";